import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"

import { actions as advisersActions } from "../../modules/advisersModule"
import { actions as appActions } from "../../modules/appModule"
import { actions as commonActions } from "../../modules/commonModule"
import { actions as userActions } from "../../modules/userModule"
import { actions as synopsisActions } from "../../modules/synopsisModule"
import { actions as lseActions } from "../../modules/lseModule"
import { actions as newsActions } from "../../modules/newsModule"

import { COLOR, STATUS } from "../../modules/constants"
import { API_CALLS, CORE_ENTITIES, DATA_SANITY_CHECKS, TIME_STAMPS } from "../../modules/synopsisConstants"

// components
import Navbar from "../../components/layout/DashboardNavbar"
import MainSection from "../../components/layout/MuiMainSection"
import ScrollableContentCard, { Padding } from "../../components/layout/ScrollableContentCard"
import Footer from "../../components/Footer"
import { formatDate_toLocal } from "../../modules/utilities"
import { LoadFavouritesAndLSEs } from "../companiesHouse/pageFunctions/loadFavouritesAndLSEs"

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from "@mui/material"

class Status extends Component {

  componentDidMount() {
    // console.log("%ccomponentDidMount() this.props: ", "background: #ccf2ff", this.props)
    // Ensure favourites and LSEs are loaded and synced
    LoadFavouritesAndLSEs(this.props)
  }

  SynopsisTable = ({ status, values, constant, title }) => {
    const rows = Object.entries(constant).map(([name, values]) => ({
      name,
      ...values,
    }))
    return (
      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Typography variant="h6" sx={{ p: 2 }}>
          {title}
        </Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Label</TableCell>
              {/* <TableCell>Key</TableCell> */}
              <TableCell align="right">Min</TableCell>
              <TableCell align="right">Max</TableCell>
              <TableCell align="right">Value</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.name}>
                <TableCell>{row.name}</TableCell>
                {/* <TableCell>{row.key}</TableCell> */}
                <TableCell align="right">{this.format(row.min)}</TableCell>
                <TableCell align="right">{this.format(row.max)}</TableCell>
                <TableCell
                  align="right"
                  sx={{ background: this.getColor(status[row.name]), color: "white" }}
                >{this.format(values[row.name])}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer >
    )
  }

  format = value => {
    if (value === null || value === undefined)
      return '-'
    else if (typeof (value) === 'number')
      return value.toLocaleString()
    else if (value instanceof Date) {
      return formatDate_toLocal(value)
    } else
      return '-'
  }

  // 🟢 Colour function (red → green)
  getColor(status) {
    if (status === STATUS.GOOD) return COLOR.GOOD
    else if (status === STATUS.WARN) return COLOR.WARN
    else if (status === STATUS.BAD) return COLOR.BAD
    else return "gray"
  }

  render() {
    const { data, portrait, synopsis, urlSource } = this.props
    // console.log("data", data)

    if (!data) {
      synopsis.get()
      return null
    }

    const club350 = API_CALLS.CLUB350
    const numerable = API_CALLS.NUMERABLE

    return (
      <React.Fragment>
        <Navbar
          title="Bookmarks"
          backLink
          portrait={portrait}
        />

        <MainSection portrait={true}>
          <ScrollableContentCard limitedWidth>
            <Padding>
              {this.SynopsisTable({ ...data.general, constant: TIME_STAMPS, title: "Time Stamps" })}
              {this.SynopsisTable({ ...data.general, constant: CORE_ENTITIES, title: "Core Entities" })}
              {this.SynopsisTable({ ...data.general, constant: DATA_SANITY_CHECKS, title: "Data Sanity Checks" })}

              {this.SynopsisTable({ ...data.api[club350.ID].companies, constant: club350.COMPANIES, title: `${club350.ID}: Companies Api Call` })}
              {this.SynopsisTable({ ...data.api[club350.ID].newsMeta, constant: club350.NEWS_META, title: `${club350.ID}: News Meta Api Call` })}
              {this.SynopsisTable({ ...data.api[club350.ID].newsRelease, constant: club350.NEWS_RELEASE, title: `${club350.ID}: News Release Api Call` })}

              {this.SynopsisTable({ ...data.api[numerable.ID].companies, constant: numerable.COMPANIES, title: `${numerable.ID}: Companies Api Call` })}
              {this.SynopsisTable({ ...data.api[numerable.ID].newsMeta, constant: numerable.NEWS_META, title: `${numerable.ID}: News Meta Api Call` })}
              {this.SynopsisTable({ ...data.api[numerable.ID].newsRelease, constant: numerable.NEWS_RELEASE, title: `${numerable.ID}: News Release Api Call` })}
            </Padding>
          </ScrollableContentCard>
        </MainSection >

        <Footer urlSource={urlSource} />
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ app, common, user, synopsis }) => {
  return {
    features: app.features,
    userDetailsChangedError: app.userDetailsChangedError,

    currentUrl: common.currentUrl,
    radio: common.radio,
    searchStringObj: common.searchStringObj,
    urlSource: common.urlSource,

    data: synopsis.data,

    portrait: user.portrait,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    advisers: bindActionCreators(advisersActions, dispatch),
    app: bindActionCreators(appActions, dispatch),
    common: bindActionCreators(commonActions, dispatch),
    lse: bindActionCreators(lseActions, dispatch),
    news: bindActionCreators(newsActions, dispatch),
    synopsis: bindActionCreators(synopsisActions, dispatch),
    user: bindActionCreators(userActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Status)
